const test = {
  env: 'test',
  backendUrl: 'http://localhost:3000',
  hasDebug: true,
  hasMocks: true,
  isTest: true,
}

export default test
